import React from "react";
import './dis.css';


const dis = () => {

    return (

        <div className="container">
            <div className="row">
                <div className="col-md-12">
                    <h1 className="text-center">DISCLAIMER POLICY</h1>
                    <p>
                        The information contained in this website is for general information purposes only. The information is provided by VREON Tech India Pvt Ltd and while we endeavor to keep the information up to date and correct, we make no representations or warranties of any kind, express or implied, about the completeness, accuracy, reliability, suitability or availability with respect to the website or the information, products, services, or related graphics contained on the website for any purpose. Any reliance you place on such information is therefore strictly at your own risk.
                        In no event will we be liable for any loss or damage including without limitation, indirect or consequential loss or damage, or any loss or damage whatsoever arising from loss of data or profits arise out of, or in connection with, the use of this website.
                        Through this website you are able to link to other websites which are not under the control of VREON Tech India Pvt Ltd. We have no control over the nature, content and availability of those sites. The inclusion of any links does not necessarily imply a recommendation or endorse the views expressed within them.
                        Every effort is made to keep the website up and running smoothly. However, VREON Tech India Pvt Ltd takes no responsibility for, and will not be liable for, the website being temporarily unavailable due to technical issues beyond our control.
                        VREON Tech India Pvt Ltd is located at –
                        Address: 4th Floor, Cisons Complex, Montieth Road, Egmore, Chennai, 600 008
                        Email: info@vreontech.com
                        Website: www.vreontech.com</p>
                </div>
            </div>
        </div>


    );

};




export default dis;